export class PartnerModel {
  id?: string;
  name?: string;
  description?: string;
  link?: string;
  isSupplier?: boolean;
  imageUrlFilePath?: string;
  imageUrl?: string;
  updatedAt?: number;
  createdAt?: number;
}
